var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1154 4.2002H11.9704C11.5646 4.2002 11.2354 4.50664 11.2354 4.8827V17.1677C11.2354 17.5451 11.5646 17.8502 11.9704 17.8502H17.1154C17.5211 17.8502 17.8504 17.5451 17.8504 17.1677V4.8827C17.8504 4.50596 17.5211 4.2002 17.1154 4.2002ZM16.3804 16.4852H15.6454V15.1202H13.4404V16.4852H12.7054V5.5652H16.3804V16.4852Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03039 5.5652H7.56039V4.2002H6.09039V5.5652H3.88539C3.47967 5.5652 3.15039 5.87164 3.15039 6.2477V17.1677C3.15039 17.5451 3.47967 17.8502 3.88539 17.8502H9.03039C9.43611 17.8502 9.76539 17.5451 9.76539 17.1677V6.2477C9.76539 5.87096 9.43611 5.5652 9.03039 5.5652ZM8.29539 16.4852H7.56039V15.1202H5.35539V16.4852H4.62039V6.9302H8.29539V16.4852Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6454 6.93018H13.4404V8.29518H15.6454V6.93018Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56047 8.29541H5.35547V9.66041H7.56047V8.29541Z",
    fill: "#959595"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56047 11.0254H5.35547V12.3904H7.56047V11.0254Z",
    fill: "#959595"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6454 9.66016H13.4404V11.0252H15.6454V9.66016Z",
    fill: "#959595"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6454 12.3901H13.4404V13.7551H15.6454V12.3901Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.6a2a5f016928799ae90ab32dfe0583df.svg";
export { ForwardRef as ReactComponent };